import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
const includes = ['Biblioteca principal (4.000+ patrones)', '7 Bonos premium exclusivos', 'Acceso inmediato y de por vida', 'Actualizaciones constantes gratuitas', 'Compatible con celular, tablet y PC'];
export function OfferSummary() {
  return <section className="py-12 px-6 bg-cream/50" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-premium border-2 border-gold-light/50 relative overflow-hidden" data-id="element-162">
          <div className="absolute -top-12 -right-12 w-32 h-32 bg-rose-light/30 rounded-full blur-2xl" data-id="element-163"></div>
          <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-gold-light/20 rounded-full blur-2xl" data-id="element-164"></div>

          <div className="relative z-10" data-id="element-165">
            <h2 className="text-2xl md:text-3xl font-bold text-dark mb-6 font-serif text-center" data-id="element-166">
              RESUMEN DE TU ACCESO
            </h2>

            <div className="space-y-3 mb-8 bg-cream/30 p-6 rounded-2xl border border-rose-light/20" data-id="element-167">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-168">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-169" />
                  <span className="text-dark/80 font-medium" data-id="element-170">{item}</span>
                </div>)}
            </div>

            <div className="space-y-4 mb-8 max-w-sm mx-auto" data-id="element-171">
              <div className="flex justify-between items-center text-lg" data-id="element-172">
                <span className="text-dark/70" data-id="element-173">Valor total:</span>
                <span className="font-bold text-dark/40 line-through" data-id="element-174">
                  $205.920 ARS
                </span>
              </div>
              <div className="flex justify-between items-center text-2xl font-bold" data-id="element-175">
                <span className="text-dark" data-id="element-176">Hoy:</span>
                <span className="text-rose-deep" data-id="element-177">$19.990 ARS</span>
              </div>
              <div className="w-full h-[1px] bg-dark/10 my-2" data-id="element-178"></div>
              <div className="flex justify-between items-center text-lg font-bold text-green-600 bg-green-50 p-3 rounded-xl border border-green-100" data-id="element-179">
                <span data-id="element-180">Ahorrás:</span>
                <span data-id="element-181">$185.930 ARS</span>
              </div>
            </div>

            <div className="flex justify-center" data-id="element-182">
              <CTAButton size="large" data-id="element-183" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}